import { Component, input, output, signal } from '@angular/core';
import { AppTranslationPipe } from '@adapter/i18n/app-translation.pipe';

@Component({
  selector: 'app-report-delete-success-card',
  imports: [AppTranslationPipe],
  templateUrl: './report-delete-success-card.component.html',
  styleUrl: './report-delete-success-card.component.scss'
})
export class ReportDeleteSuccessCardComponent {
  loadId = input<string>('');
  policyNumber = input<string>('');

  isClosing = signal(false);

  cleared = output<void>();

  close(): void {
    this.isClosing.set(true);
    setTimeout(() => {
      this.isClosing.set(false);
      this.cleared.emit();
    }, 250);
  }
}